import {Office} from '@innowise-group/core';
import {Form, withForm, WithFormProps} from '@innowise-group/ui-kit';
import {useFormContext} from 'react-hook-form';
import OfficeFormLayout, {OfficeFormValues} from './office-form-layout.component';

export type AddOfficeFormSection = 'location' | 'floor';

export type AddOfficeFormValues = OfficeFormValues;

const AddOfficeForm: React.FC<
  WithFormProps<AddOfficeFormValues> & {
    sectionsToShow?: AddOfficeFormSection[];
    offices?: Office[];
  }
> = ({onSubmit, onCancel, initialValues = {}, sectionsToShow = ['location', 'floor'], isSubmit, offices}) => {
  const {handleSubmit} = useFormContext();

  return (
    <Form.Container onSubmit={handleSubmit(onSubmit)}>
      <OfficeFormLayout
        sectionsToShow={sectionsToShow}
        initialValues={initialValues}
        onCancel={onCancel}
        isSubmit={isSubmit}
        offices={offices}
      />
    </Form.Container>
  );
};

export default withForm(AddOfficeForm);
